module.exports = __webpack_public_path__ + "img/2020_20200118_120604.d7c0ca40.jpg";